import { motion } from "framer-motion";

const PILLARS = [
  { num: "01", title: "True Goan Ground Presence", desc: "Based in Goa itself. If you need roadside help, a doctor on call, or a table at a packed club — we are already here." },
  { num: "02", title: "Zero Hidden Costs", desc: "Fuel, tolls, driver allowances, hotel taxes and entry permits specified upfront. What we quote is what you pay." },
  { num: "03", title: "Handpicked Stays & Fleets", desc: "We personally audit our hotels and vehicles so your family travels in clean, premium comfort." },
  { num: "04", title: "Instant WhatsApp Concierge", desc: "One dedicated travel manager on WhatsApp from your first enquiry until you fly back home." },
];

export default function WhyChoose() {
  return (
    <section id="why-choose" data-testid="why-choose-section" className="relative py-20 sm:py-28 bg-navy-deep border-y border-gold/10 grain">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="grid lg:grid-cols-2 gap-10 lg:gap-16 mb-14"
        >
          <div>
            <p className="text-[11px] sm:text-xs uppercase tracking-[0.32em] text-gold font-semibold mb-4">Why Choose Us</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
              Why Travellers Trust <span className="gold-text italic">RAJ TRAVELS GOA</span>
            </h2>
          </div>
          <p className="text-sm sm:text-base text-slate-300 leading-relaxed lg:self-end lg:text-right lg:max-w-md lg:ml-auto">
            We are not a faceless booking website. We are Goan locals who know every hidden cove,
            the freshest shack curry and the best sunset vantage points — and we plan your holiday like our own.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-gold/10 rounded-3xl overflow-hidden border border-gold/10">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.num}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1, duration: 0.65 }}
              data-testid={`why-pillar-${p.num}`}
              className="bg-navy-deep p-7 sm:p-8 hover:bg-navy-card transition-colors duration-500 group"
            >
              <span className="font-cinzel text-4xl sm:text-5xl text-gold/25 group-hover:text-gold/50 transition-colors duration-500 font-bold">
                {p.num}
              </span>
              <h3 className="mt-5 font-display text-lg sm:text-xl font-semibold leading-snug">{p.title}</h3>
              <p className="mt-3 text-[13px] text-slate-400 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
